import { render, staticRenderFns } from "./TeacherWorkRegimeRule.vue?vue&type=template&id=2813e98e"
import script from "./TeacherWorkRegimeRule.vue?vue&type=script&lang=js"
export * from "./TeacherWorkRegimeRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports